export function useScrollToElement() {
    const scrollTo = (element: HTMLElement) => {
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    };

    const scrollToTop = (element: HTMLElement) => {
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    };

    const scrollToBottom = (element: HTMLElement) => {
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'end'});
        }
    };

    return {
        scrollTo,
        scrollToBottom,
        scrollToTop,
    };
}
